// src/router/index.js
import Vue from 'vue';
import Router from 'vue-router';
import SignInPage from '../components/SignInPage.vue'
import MakeSure from '../components/MakeSure.vue'
import formData from '../components/formData.vue'
import overRitht from '../components/overRitht.vue'
import makeSureText from '../components/makeSureText.vue'
import newHttp  from '../components/newHttp.vue'
import kong  from '../components/kong.vue'
import teacherPage  from '../components/teacherPage.vue'

Vue.use(Router);
const routes = [
    {
        path: '/signin',
        name: 'SignInPage',
        component: SignInPage
    },
    {
        path: '/success',
        name: 'MakeSure',
        component: MakeSure
    },
    {
        path: '/',
        redirect: '/signin' // 默认跳转到登录页
    },
    {
        path: '/formData',
        name: 'formData',
        component:  formData
    },
    {
        path: '/overRitht',
        name: 'overRitht',
        component:  overRitht
    },
    {
        path: '/makeSureText',
        name: 'makeSureText',
        component:  makeSureText
    },
    {
        path: '/newHttp',
        name: 'newHttp',
        component:  newHttp
    },
    {
        path: '/kong',
        name: 'kong',
        component:  kong
    },
    {
        path: '/teacherPage',
        name: 'teacherPage',
        component:  teacherPage
    },
]

const router = new Router({
  mode: 'history', // 使用 HTML5 History 模式
  routes // （缩写）相当于 routes: routes
});

export default router